import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type RestrictionType = "feature" | "resource" | "feature_quota" | null;

export type FeatureQuotaData = {
  feature: string;
  scope: string | null;
  limit: number;
  used: number;
  resetsAt: string | null;
};

export type AccessControlState = {
  type: RestrictionType;
  code: string | null;
  quotaData: FeatureQuotaData | null;
};

const initialState: AccessControlState = {
  type: null,
  code: null,
  quotaData: null,
};

const accessControlSlice = createSlice({
  name: "accessControl",
  initialState,
  reducers: {
    showFeatureRestrictionPopup: (state, action: PayloadAction<string>) => {
      state.type = "feature";
      state.code = action.payload;
      state.quotaData = null;
    },
    showResourceRestrictionPopup: (state, action: PayloadAction<string>) => {
      state.type = "resource";
      state.code = action.payload;
      state.quotaData = null;
    },
    showFeatureQuotaRestrictionPopup: (state, action: PayloadAction<FeatureQuotaData>) => {
      state.type = "feature_quota";
      state.code = action.payload.feature;
      state.quotaData = action.payload;
    },
    hideRestrictionPopup: (state) => {
      state.type = null;
      state.code = null;
      state.quotaData = null;
    },
  },
});

export const {
  showFeatureRestrictionPopup,
  showResourceRestrictionPopup,
  showFeatureQuotaRestrictionPopup,
  hideRestrictionPopup,
} = accessControlSlice.actions;

export default accessControlSlice.reducer;
